module.exports = __webpack_public_path__ + "static/img/son1_active.580e2a51.png";